import { PositionDetails } from './typings';

export enum POSITION_TYPE {
  Opened,
  Closed,
}

export const GET_POSITIONS = 'GET_POSITIONS';
export const CONVERT_POSITION = 'CONVERT_POSITION';
export const BUY = 'B';
export const SELL = 'S';

export const CONTEXT_MENU_OPTIONS = {
  SIMPLE: {
    INTRADAY: {
      FULL: [
        'Square off',
        'Symbol info',
        'Convert positions',
        'Position Details',
      ],
      ZERO: ['Symbol info', 'Position Details'],
      SINGLE: [
        'Square off',
        'Symbol info',
        'Convert position',
        'Position Details',
      ],
    },
    MTF: ['Square off', 'Symbol info', 'Position Details'],
  },
  CO_ZERO_QUANTITY: ['Symbol info', 'Position Details'],
  CO: ['Square off', 'Symbol info', 'Position Details', 'Modify Order'],
};

export const DEFAULT_POSITION_DETAILS: PositionDetails = {
  netQty: 0,
  pnl: {
    unrealized: 0,
    realized: 0,
    total: 0,
  },
  product: 'I',
  netBuyQty: 0,
  netSellQty: 0,
  avgBuyPrice: 0,
  avgSellPrice: 0,
  avgPrice: 0,
  avgCfPrice: '',
  buyValue: 0,
  sellValue: 0,
  multiplier: 1,
};

export const convertPositionErrorMessages = (boardLot?: number) =>
  ({
    emptyLotSize: 'Lot size unavailable at the moment, please try later',
    multiplierError: `Quantity must be a multiple of lot size ( Lot size = ${boardLot ??
      ''} )`,
    lessThanOne: "Quantity can't be less than 1",
    insufficientQty: 'Insufficient available quantity',
    lessOrEqual: 'Quantity must be a less than or equal to available',
    incorrectValue: 'Please, enter the valid value',
  } as const);
export const initialSort = {
  id: null,
  clickCount: 1,
};

export const INTERACTIVE_ORDER_CONVERT_POSITION_URL =
  '/service-upstox/interactive/v1/convert-position';
